module.exports = __webpack_public_path__ + "aa81c415ff2796baaa403f878f034216.png";